import Header from '../header/Header'
import MainContent from '../content/MainContent'
import UserAppContext from '../../hook/UserAppContext'

const Container = () => {

      const {user} = UserAppContext()

      if(user.length === 0) return

      return (
            <div className="container">
                  <Header />
                  <MainContent />
            </div>
      )
}

export default Container;